import { Grid } from '@mui/material';
import './panoramaViewer.scss';
import { skuTypes } from './types';
import { HomeObjectProduct } from '../../models/homes.models';
import { devOnlyCloudinaryInstance } from '../../utils/images.tsx';

interface PanoramaMenuItemProps {
  sku: string;
  currentSkuGroupId: skuTypes;
  setSkuId: (groupId: string, skuId: string) => void;
  homeModelProducts: HomeObjectProduct[];
  styleId: string;
  locationId: string;
  homeId: string;
}

export const PanoramaMenuItem = (props: PanoramaMenuItemProps) => {
  const {
    sku,
    currentSkuGroupId,
    setSkuId,
    homeModelProducts,
    styleId,
    locationId,
    homeId,
  } = props;

  // converst styleId to style usable for search
  const styleCodes = {
    int_contemporary: 'C',
    contemporary: 'C',
    int_modern_cottage: 'MC',
    modern_cottage: 'MC',
    int_coastal: 'CWI',
    coastal: 'CWI',
    zen_modern: 'ZM',
    ext_style_1: 'EXT1',
    ext_style_2: 'EXT2',
    ext_style_3: 'EXT3',
  };

  // converst locatoinId to style usable for search
  const roomCodes = {
    int_kitchen_dining: 'Kitchen',
    int_living: 'Living',
    ext_front: 'Style',
    ext_back: 'Style',
    int_living_room: 'Living',
    int_dining_room: 'Kitchen',
  };

  const names = {
    int_kitchen_dining: 'Kitchen',
    int_living: 'Living Room ',
    ext_front: 'Front Yard',
    ext_back: 'Backyard',
    int_living_room: 'Living',
    int_dining_room: 'Kitchen',
    ext_style_1: 'Exterior Style 1',
    ext_style_2: 'Exterior Style 2',
    ext_style_3: 'Exterior Style 3',
    int_coastal: 'Coastal',
    int_modern_cottage: 'Modern Cottage',
    int_contemporary: 'Contemporary',
    int_zen_modern: 'Zen Modern',
  };

  const matchingSkus = homeModelProducts.filter(
    (element) => element.sku === sku.toLowerCase()
  );

  const productTypeMap = {
    kitchen_cabinets: 'Cabinet',
    kitchen_hardware: 'Hardware',
    kitchen_countertops: 'Countertop',
    countertops: 'Countertop',
    kitchen_island: 'Island',
    floor: 'Floor',
    floors: 'Floor',
    '@locations': 'Location',
    '@styles': 'Style',
    exterior_finish: 'Exterior',
    siding: 'Siding',
    roof: 'Roof',
    cladding: 'Cladding',
    window: 'Window',
  };

  let product: HomeObjectProduct | undefined;

  if (matchingSkus.length === 1) {
    product = matchingSkus[0];
  } else {
    product = matchingSkus.find((element) => {
      const productType = productTypeMap[currentSkuGroupId];
      if (!productType) return false;

      if (
        currentSkuGroupId === '@locations' ||
        currentSkuGroupId === '@styles'
      ) {
        return true;
      }

      return (
        element.category?.name?.includes(productType) ||
        element.category?.name?.includes(productType + 's') || // Handle plural form
        element.name?.includes(productType)
      );
    });
  }

  const room = homeModelProducts.find((element) => {
    if (sku === 'ext_front') {
      if (homeId === 'la_mer_01') {
        return element.name.includes(`Front - Le Mer`);
      } else {
        return element.name.includes(
          ` EXT1 - ${roomCodes[sku as keyof typeof roomCodes]}`
        );
      }
    }

    if (sku === 'ext_back') {
      if (homeId === 'la_mer_01') {
        return element.name === `Back - Le Mer`;
      } else {
        return element.name.includes(
          ` EXT2 - ${roomCodes[sku as keyof typeof roomCodes]}`
        );
      }
    }

    if (locationId === 'ext_back' || locationId === 'ext_front') {
      if (sku === 'int_living') {
        return element.name.includes(` C - Living`);
      }
      if (sku === 'int_kitchen_dining') {
        return element.name.includes(` C - Kitchen`);
      }
    }

    return element.name.includes(
      ` ${styleCodes[styleId as keyof typeof styleCodes]} - ${roomCodes[sku as keyof typeof roomCodes]}`
    );
  });

  // product?.name ? product?.name : sku
  const itemName = () => {
    if (names[sku as keyof typeof names]) {
      return names[sku as keyof typeof names];
    } else if (product?.name) {
      return product?.name;
    }
    return sku;
  };

  const style = homeModelProducts.find((element) => {
    return element.name.includes(
      ` ${styleCodes[sku as keyof typeof styleCodes]} - ${roomCodes[locationId as keyof typeof roomCodes]}`
    );
  });

  return (
    <Grid size={12}>
      <div>
        <Grid
          container
          onClick={() => setSkuId(currentSkuGroupId, sku)}
          style={{ border: '1px solid #D2D2D2' }}
          className="panorama-item-container"
        >
          <Grid
            style={{ height: '150px', zIndex: 200, overflow: 'hidden' }}
            size={5}
          >
            <img
              style={{
                height: '100%',
                width: 'auto',
                opacity: product || room || style ? 1 : 0,
              }}
              src={
                product || room || style
                  ? devOnlyCloudinaryInstance
                      .image(
                        product
                          ? product.thumbnail_key
                          : room
                            ? room?.thumbnail_key
                            : style?.thumbnail_key
                      )
                      .toURL()
                  : 'https://placehold.co/150x150'
              }
              alt=""
            />
          </Grid>
          <Grid style={{ margin: 'auto', textAlign: 'center' }} size={7}>
            <p
              style={{
                color: '#002D56',
                fontFamily: 'serif',
                fontSize: '16px',
                marginBottom: 0,
                textTransform: 'capitalize',
              }}
            >
              {itemName()}
            </p>
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
};
